import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleEditor',
  props: {
  content: {
    type: String,
    required: false,
  },
},
  emits: ["onChange"],
  setup(__props, { emit }) {

const props = __props;




const editor = ref();

function onReady(e: any) {
  editor.value = e;
  e.container.querySelector(".ql-blank").innerHTML = props.content;
}

function onContentChange() {
  const html = editor.value.container.querySelector(".ql-editor").innerHTML;
  emit("onChange", html);
}

return (_ctx: any,_cache: any) => {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!

  return (_openBlock(), _createBlock(_component_QuillEditor, {
    theme: "snow",
    onReady: onReady,
    "onUpdate:content": onContentChange
  }))
}
}

})